import i18n from "i18next";

export const GetMetamatchLink = (): string => {
  const lang = i18n.language !== "it" ? i18n.language : "";

  return `https://metamatch.takyon.io/${lang}`;
};
